/**
 * Video Enhancement Script
 * Handles portrait video detection and proper display
 */

class VideoEnhancer {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.enhanceVideos());
    } else {
      this.enhanceVideos();
    }

    // Re-run when new content is loaded (for AJAX/dynamic content)
    document.addEventListener('content:loaded', () => this.enhanceVideos());
  }

  enhanceVideos() {
    // Enhance product slider videos
    this.enhanceProductSliderVideos();
    
    // Enhance main product videos
    this.enhanceMainProductVideos();
    
    // Enhance general videos
    this.enhanceGeneralVideos();
  }

  enhanceProductSliderVideos() {
    const sliderVideos = document.querySelectorAll('.mps-product-video');
    
    sliderVideos.forEach(video => {
      this.handleVideoLoad(video, (aspectRatio) => {
        const container = video.closest('.mps-product-image');
        if (!container) return;

        if (aspectRatio <= 0.8) { // Portrait video
          container.setAttribute('data-video-aspect', 'portrait');
          container.classList.add('mps-portrait-video');
        } else {
          container.setAttribute('data-video-aspect', 'landscape');
          container.classList.remove('mps-portrait-video');
        }
      });
    });
  }

  enhanceMainProductVideos() {
    const productVideos = document.querySelectorAll('.product-single__media-native-video video');
    
    productVideos.forEach(video => {
      this.handleVideoLoad(video, (aspectRatio) => {
        const container = video.closest('.product-single__media-native-video');
        if (!container) return;

        if (aspectRatio <= 0.8) { // Portrait video
          container.setAttribute('data-video-aspect', 'portrait');
        } else {
          container.setAttribute('data-video-aspect', 'landscape');
        }
      });
    });
  }

  enhanceGeneralVideos() {
    const allVideos = document.querySelectorAll('video:not(.mps-product-video):not(.product-single__media-native-video video)');
    
    allVideos.forEach(video => {
      this.handleVideoLoad(video, (aspectRatio) => {
        if (aspectRatio <= 0.8) { // Portrait video
          video.setAttribute('data-video-aspect', 'portrait');
          video.style.objectFit = 'contain';
          
          const container = video.parentElement;
          if (container) {
            container.style.background = '#000';
          }
        }
      });
    });
  }

  handleVideoLoad(video, callback) {
    const processVideo = () => {
      if (video.videoWidth && video.videoHeight) {
        const aspectRatio = video.videoWidth / video.videoHeight;
        callback(aspectRatio);
      }
    };

    // Check if video is already loaded
    if (video.readyState >= 1) {
      processVideo();
    } else {
      // Wait for video metadata to load
      video.addEventListener('loadedmetadata', processVideo, { once: true });
      
      // Fallback: try to load the video
      if (video.load && video.readyState === 0) {
        video.load();
      }
    }

    // Alternative method: parse aspect ratio from CSS custom property if available
    const container = video.closest('[style*="--aspect-ratio"]');
    if (container) {
      const styleAttribute = container.getAttribute('style');
      const aspectRatioMatch = styleAttribute.match(/--aspect-ratio:\s*([0-9.]+)/);
      
      if (aspectRatioMatch) {
        const aspectRatio = parseFloat(aspectRatioMatch[1]);
        callback(aspectRatio);
      }
    }
  }

  // Public method to refresh video enhancements
  refresh() {
    this.enhanceVideos();
  }
}

// Auto-initialize
const videoEnhancer = new VideoEnhancer();

// Export for manual use
window.VideoEnhancer = VideoEnhancer;
window.videoEnhancer = videoEnhancer;

// Re-run enhancements when page content changes
if (window.Shopify && window.Shopify.theme) {
  document.addEventListener('shopify:section:load', () => videoEnhancer.refresh());
  document.addEventListener('shopify:section:reorder', () => videoEnhancer.refresh());
}
